import React from 'react';
import PropTypes from 'prop-types';

const SidebarMenu = (props) => {
	const { handleClick, sidebar } = props;

	return (
		<div className="SidebarMenu">
			{!sidebar && (
				<button
					className="sidebar-menu-burger"
					aria-expanded="false"
					aria-label="Trailhead and Trips Side Menu"
					onClick={handleClick}
				>
					<div className="arrow-right"></div>
				</button>
			)}
		</div>
	);
};

SidebarMenu.propTypes = {
	handleClick: PropTypes.func.isRequired,
	sidebar: PropTypes.bool.isRequired,
};

export default SidebarMenu;



// WEBPACK FOOTER //
// ./map/components/SidebarMenu.js